import { safetyTips } from "@/mocks/homeData";

export default function SafetySection() {
  return (
    <section className="w-full bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            安全访问指南
          </h2>
          <p className="text-foreground-600 max-w-lg mx-auto text-sm md:text-base">
            保护您的账户安全和隐私，远离钓鱼网站威胁
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {safetyTips.map((tip) => (
            <div
              key={tip.id}
              className="p-5 rounded-2xl bg-background-50 border border-accent-100/60"
            >
              <span className="w-10 h-10 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4">
                <i className={`${tip.icon} text-lg`}></i>
              </span>
              <h3 className="font-semibold text-foreground-900 mb-2 text-sm">{tip.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{tip.content}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}